class MiniCart extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const content = this.getSectionInnerHTML(html);
        // Sur les pages app proxy (portail Recharge /tools/recurring), la requête peut
        // renvoyer la page de l'app au lieu de la section : on ne remplit pas le tiroir
        // avec un contenu qui n'est pas le mini-cart.
        if (content === null) {
          console.error('mini-cart section not found in response for', this.dataset.url);
          return;
        }

        document.getElementById('mini-cart').innerHTML = content;

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));

        // Vérifiez si l'élément est présent après avoir défini le contenu
        this.getDeliveryDate(); // Appeler après avoir mis à jour le DOM
                if (typeof yotpoWidgetsContainer !== 'undefined' &&
            typeof yotpoWidgetsContainer.initWidgets === 'function') {
          yotpoWidgetsContainer.initWidgets(false);
        }
      })
      .catch(e => {
        console.error(e);
      });
  }


  open() {
    const detailsElement = this.drawer.querySelector('details');

    if (detailsElement.hasAttribute('open')) {
      return;
    }

    // Le nettoyage des cadeaux orphelins ne se declenchait que sur mouvement du
    // panier (ajout, changement de quantite) : aucun appel sur DOMContentLoaded.
    // Un client qui reprend un vieux panier et va droit au checkout gardait donc
    // son cadeau perime. L'ouverture du drawer precede quasiment tous les
    // parcours de paiement. Asynchrone : openMenuDrawer() part sans attendre,
    // le panier se corrige quand la promesse se resout.
    if (typeof checkGiftProduct === 'function') checkGiftProduct();

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState, openCartDrawer = true) {
    this.productId = parsedState.id;

    // L'API Cart ne renvoie pas de `sections` quand `sections_url` n'est pas une page
    // rendue par le thème (cf. theme.sectionsUrl) : on le signale au lieu de planter.
    if (!parsedState.sections) {
      console.error('Cart response has no rendered sections', parsedState);
      (openCartDrawer) && this.open();
      return;
    }

    this.getSectionsToRender().forEach((section => {
      const target = document.getElementById(section.id);
      if (!target) return;

      const content = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (content === null) {
        console.error(`Section "${section.section}" not found in response`);
        return;
      }

      target.innerHTML = content;
    }));

    (openCartDrawer) && this.open();
  }

  refreshSections(openCartDrawer = false) {
    const sections = this.getSectionsToRender().map((s) => s.section).join(',');
    return fetch(`${window.Shopify.routes.root}?sections=${sections}`)
      .then((response) => response.json())
      .then((parsed) => this.renderContents({ sections: parsed }, openCartDrawer))
      .catch((e) => console.error(e));
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
  getDeliveryDate() {
    if (typeof theme !== 'undefined' && typeof theme.getDeliveryDate === 'function') {
      const fromDate = theme.getDeliveryDate();
      let options = { weekday: 'long', month: 'long', day: 'numeric' };
      const text = this.querySelector('#fromDate');
      if (text) {
        text.innerHTML = fromDate.toLocaleDateString('fr-FR', options);
      } else {
        console.error('Element with id "fromDate" not found inside mini-cart.');
      }
    }
  }

  getSectionInnerHTML(html, selector = '#shopify-section-mini-cart') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section = doc.querySelector(selector);
    return section ? section.innerHTML : null;
  }
}
const ScrollLock = {
  lock() {
    const root = document.documentElement;
    if (root.classList.contains('mm-scroll-locked')) return;
    const y = window.scrollY || 0;
    document.body.dataset.mmScrollY = y;
    root.classList.add('mm-scroll-locked');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  },
  unlock() {
    const root = document.documentElement;
    if (!root.classList.contains('mm-scroll-locked')) return;
    const y = parseInt(document.body.dataset.mmScrollY || '0', 10);
    root.classList.remove('mm-scroll-locked');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    delete document.body.dataset.mmScrollY;
    window.scrollTo(0, y);
  }
};

customElements.define('mini-cart', MiniCart);

